import { NavLink } from 'react-router-dom';
import {
  HomeIcon,
  MagnifyingGlassIcon,
  GlobeAltIcon,
  MapIcon,
  ArrowsRightLeftIcon,
  ChatBubbleLeftEllipsisIcon,
  Cog6ToothIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import clsx from 'clsx';

const navigation = [
  { name: 'Dashboard', href: '/', icon: HomeIcon },
  { name: 'Find Estate', href: '/find', icon: MagnifyingGlassIcon },
  { name: 'Proposed Estates', href: '/proposed-estates', icon: MapIcon },
  { name: 'Browse BlocPlus', href: '/blocplus', icon: GlobeAltIcon },
  { name: 'Merge Plans', href: '/merge', icon: ArrowsRightLeftIcon },
  { name: 'Ask Lotti', href: '/lotti', icon: ChatBubbleLeftEllipsisIcon },
  { name: 'Settings', href: '/settings', icon: Cog6ToothIcon },
];

interface NavigationMenuProps {
  isOpen?: boolean;
  onClose?: () => void;
}

export const NavigationMenu = ({ isOpen, onClose }: NavigationMenuProps) => {
  return (
    <>
      {/* Backdrop for mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/40 md:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <nav
        className={clsx(
          'fixed left-0 top-0 z-40 h-screen w-64 border-r border-gray-300 bg-white p-6 transition-transform duration-200',
          'md:translate-x-0',
          isOpen ? 'translate-x-0' : '-translate-x-full'
        )}
      >
        <div className="mb-8 flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gold">EstateMate</h1>
            <p className="text-xs text-gray-600">Estate Conversion Tool</p>
          </div>
          <button
            onClick={onClose}
            className="rounded-lg p-1 text-gray-500 hover:bg-gray-100 md:hidden"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>
        <ul className="space-y-2">
          {navigation.map((item) => (
            <li key={item.name}>
              <NavLink
                to={item.href}
                onClick={onClose}
                className={({ isActive }) =>
                  clsx(
                    'flex items-center gap-3 rounded-lg px-4 py-3 text-s font-normal transition-colors',
                    isActive
                      ? 'bg-gold-light text-gold'
                      : 'text-gray-700 hover:bg-gray-100 hover:text-gold'
                  )
                }
              >
                <item.icon className="h-5 w-5" />
                {item.name}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
};
